<template>
  <div>
    <ClientDashboard v-if="$getConstRole('ROLE_CLIENT') == role"></ClientDashboard>
    <AdminDashboard v-if="$getConstRole('ROLE_ADMIN') == role"></AdminDashboard>
    <AgentDashboard v-if="$getConstRole('ROLE_AGENT') == role"></AgentDashboard>
    <AccountantDashboard v-if="$getConstRole('ROLE_ACCOUNTING') == role"></AccountantDashboard>
    <OperationsDashboard v-if="$getConstRole('ROLE_OPERATIONS') == role"></OperationsDashboard>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ClientDashboard from '@/views/client/Dashboard.vue'
import AdminDashboard from '@/views/admin/Dashboard.vue'
import AgentDashboard from '@/views/agent/Dashboard.vue'
import AccountantDashboard from '@/views/accountant/Dashboard.vue'
import OperationsDashboard from '@/views/operations/Dashboard.vue'

export default {
  name: 'Dashboard',
  data: () => ({
    role: 0
  }),
  computed: {
    ...mapGetters(['getCurrentUser']),
  },
  mounted () {
    this.role = this.getCurrentUser.role
  },
  methods: {
  },
  components: {
    ClientDashboard,
    AdminDashboard,
    AgentDashboard,
    AccountantDashboard,
    OperationsDashboard
  },
};
</script>
